/**
 * api/users.js — User management (admin only)
 *
 * GET   /api/users
 * POST  /api/users
 * PATCH /api/users/:id
 * POST  /api/users/:id/reset-password
 */

import client from './client';

export const usersApi = {

  async getAll() {
    const { data } = await client.get('/users');
    return data.data ?? data;
  },

  async create(payload) {
    const { data } = await client.post('/users', payload);
    return data.data ?? data;
  },

  async update(id, payload) {
    const { data } = await client.patch(`/users/${id}`, payload);
    return data.data ?? data;
  },

  async resetPassword(id, newPassword) {
    const { data } = await client.post(`/users/${id}/reset-password`, {
      password:              newPassword,
      password_confirmation: newPassword,
    });
    return data;
  },
};
